import { Globe } from 'lucide-react'
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

export default function LanguageSelector({onSelect}) {
  const { i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [languageName, setLanguageName] = useState(i18n.language === 'en' ? 'עב' : 'EN')

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'he' : 'en'
    i18n.changeLanguage(newLang)

    // הוספת כיווניות למסמך
    document.documentElement.dir = newLang === 'he' ? 'rtl' : 'ltr'

    // שינוי משפחת הגופנים
    document.documentElement.style.setProperty(
        '--font-family',
        newLang === 'he' ? 'heebo, sans-serif' : 'serif'
    )

    setLanguageName(newLang === 'en' ? 'עב' : 'EN')
    const pathArray = location.pathname.split('/')
    pathArray[1] = newLang
    const newPath = pathArray.join('/')
    navigate(newPath + location.search)

      // קריאה ל-onSelect לסגירת התפריט במובייל
      if (onSelect) {
          onSelect()
      }
  }

  return (
      <button
          onClick={toggleLanguage}
          className="
        flex items-center gap-1.5
        rounded-full
        bg-[#8b5e3c1a]
        px-3 py-1.5
        text-sm font-medium
        text-[#8B5E3C]
        transition-all duration-300
        hover:bg-[#8b5e3c33]
        active:scale-95
      "
          aria-label="Toggle language"
      >
          <Globe className="h-5 w-5"/>
          <span className="min-w-[24px] text-center">
        {languageName}
      </span>
      </button>
  )
}